var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLink = function SvgLink(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M17.563 10.197a4.306 4.306 0 0 0-5.549-6.55l-.047.033a.95.95 0 0 0-.22 1.329.953.953 0 0 0 1.328.22l.047-.033a2.4 2.4 0 0 1 3.092 3.652l-3.342 3.348A2.4 2.4 0 0 1 9.22 9.104l.033-.048a.952.952 0 0 0-1.549-1.108l-.032.048a4.305 4.305 0 0 0 6.547 5.546zM2.087 9.5a4.305 4.305 0 0 0 0 6.091 4.306 4.306 0 0 0 5.549.459l.048-.033a.953.953 0 0 0-1.108-1.549l-.048.033a2.4 2.4 0 0 1-3.092-.256 2.403 2.403 0 0 1 0-3.398l3.342-3.345a2.402 2.402 0 0 1 3.652 3.095l-.033.047a.953.953 0 0 0 1.549 1.108l.032-.048a4.305 4.305 0 0 0-6.547-5.549z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export default ForwardRef;